import { render, staticRenderFns } from "./NotifyParent.vue?vue&type=template&id=6d53606f&scoped=true"
import script from "./NotifyParent.vue?vue&type=script&lang=js"
export * from "./NotifyParent.vue?vue&type=script&lang=js"
import style0 from "./NotifyParent.vue?vue&type=style&index=0&id=6d53606f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d53606f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d53606f')) {
      api.createRecord('6d53606f', component.options)
    } else {
      api.reload('6d53606f', component.options)
    }
    module.hot.accept("./NotifyParent.vue?vue&type=template&id=6d53606f&scoped=true", function () {
      api.rerender('6d53606f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/parent/NotifyParent.vue"
export default component.exports